import {createReducer} from '@reduxjs/toolkit';

import {setAccountId} from './actions';

export type State = number;

export const accountId = createReducer(NaN, builder => builder
    // .addCase('API_V2_LOAD_USER_PREFERENCES_SUCCESS', (state, action) => {
    //     state.preferences = action.payload.data;
    // })
    .addCase(setAccountId, (state, action) => {
        return action.payload;
    }),
);
